import produce from 'immer'
import { METERS_LOAD, METERS_LOAD_SUCCESS, METERS_LOAD_FAIL } from './actions'

const initialState = {
  loading: false,
  error: null,
  data: {}
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case METERS_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case METERS_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.meters
        return
      }
      case METERS_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
